import styled from 'styled-components'

export const Page = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 4px 16px 72px;
    color: #1d2422;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    .crumb {
        margin: 0 0 4px;
        color: #6b7280;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.02em;
    }

    h1 {
        margin: 0;
        font-size: 24px;
        line-height: 1.2;
        font-weight: 700;
        color: #111827;
    }

    .subtitle {
        margin: 6px 0 0;
        color: #6b7280;
        font-size: 13px;
        line-height: 1.4;
    }

    .panel {
        margin-top: 16px;
        background: #f7f8fb;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 16px;
    }

    .controls {
        display: flex;
        flex-wrap: wrap;
        gap: 14px 16px;
        align-items: flex-start;
    }

    .field {
        display: grid;
        grid-template-rows: 16px minmax(38px, auto);
        gap: 6px;
        align-content: start;
        min-width: 0;
        flex: 0 1 260px;
        width: 260px;
        max-width: 100%;
    }

    .field.report-type {
        flex: 0 0 auto;
        width: auto;
    }

    .field.months,
    .field.customers {
        flex: 1 1 280px;
        width: auto;
        min-width: min(100%, 240px);
        max-width: none;
    }

    .ui.multiple.selection.dropdown {
        height: auto !important;
        min-height: 38px !important;
        line-height: normal !important;
        white-space: normal !important;
        display: flex !important;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
        gap: 4px;
        padding: 4px 34px 4px 8px !important;
    }

    .ui.multiple.selection.dropdown > .label {
        margin: 0 !important;
        max-width: 100%;
        font-size: 12px;
        line-height: 1.25;
        white-space: normal;
    }

    .ui.multiple.selection.dropdown > .text,
    .ui.multiple.selection.dropdown > .default.text {
        margin: 0 !important;
        line-height: 28px !important;
        padding-left: 2px;
    }

    .ui.multiple.selection.dropdown > input.search {
        margin: 0 !important;
        padding: 0 !important;
        height: 28px !important;
        line-height: 28px !important;
        flex: 1 0 72px;
        min-width: 72px;
    }

    .ui.multiple.selection.dropdown > .dropdown.icon,
    .ui.multiple.selection.dropdown > .remove.icon,
    .ui.multiple.selection.dropdown > .clear.icon {
        top: 11px !important;
        margin: 0 !important;
    }

    .field label,
    .field .lbl {
        font-size: 11px;
        line-height: 16px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #6b7280;
    }

    .seg {
        display: inline-flex;
        height: 38px;
        border: 1px solid #d8ddda;
        border-radius: 8px;
        overflow: hidden;
        background: #fff;
        max-width: 100%;
        box-shadow: 0 1px 1px rgba(17, 24, 39, 0.04);
    }

    .seg button {
        border: 0;
        background: transparent;
        color: #1d2422;
        padding: 0 14px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        white-space: nowrap;
    }

    .seg button + button {
        border-left: 1px solid #d8ddda;
    }

    .seg button.on {
        background: #263ba6;
        color: #fff;
        font-weight: 650;
    }

    .seg button:disabled {
        cursor: not-allowed;
        opacity: 0.55;
    }

    .ui.selection.dropdown {
        min-width: 0 !important;
        width: 100%;
        max-width: 100%;
        min-height: 38px;
        border-radius: 8px !important;
        border-color: #d8ddda !important;
        font-size: 13px;
        box-shadow: 0 1px 1px rgba(17, 24, 39, 0.04);
    }

    .ui.selection.dropdown > .text,
    .ui.selection.dropdown > .default.text {
        line-height: 1.3;
    }

    .hint {
        margin: 10px 0 0;
        color: #6b7280;
        font-size: 12px;
        line-height: 1.4;
    }

    .btns {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        margin-top: 14px;
        padding-top: 14px;
        border-top: 1px solid #e5e7eb;
    }

    .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 38px;
        padding: 0 14px;
        border-radius: 8px;
        border: 1px solid #d8ddda;
        background: #fff;
        color: #1d2422;
        font-size: 13px;
        font-weight: 650;
        cursor: pointer;
        box-shadow: 0 1px 1px rgba(17, 24, 39, 0.04);
    }

    .btn.primary {
        background: #263ba6;
        border-color: #1f3190;
        color: #fff;
        box-shadow: 0 1px 2px rgba(38, 59, 166, 0.28);
    }

    .btn:disabled {
        cursor: not-allowed;
        opacity: 0.55;
    }

    .btn:not(:disabled):hover {
        filter: brightness(0.97);
    }

    .spinner {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 2px solid currentColor;
        border-right-color: transparent;
        animation: ph-spin 0.7s linear infinite;
    }

    @keyframes ph-spin {
        to {
            transform: rotate(360deg);
        }
    }

    .toast {
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 13px;
        margin-top: 14px;
    }

    .toast.ok {
        background: #dff1e6;
        color: #137a4a;
    }

    .toast.err {
        background: #f7d6d2;
        color: #b3261e;
    }

    .toast a {
        color: inherit;
        font-weight: 650;
        margin-right: 10px;
    }

    .empty {
        margin-top: 14px;
        border: 1px dashed #d8ddda;
        border-radius: 8px;
        padding: 18px 14px;
        text-align: center;
        color: #5f6b67;
        font-size: 14px;
        background: #fff;
    }

    .preview-list {
        display: grid;
        gap: 16px;
        margin-top: 16px;
    }

    .preview-list .preview {
        margin-top: 0;
    }

    .preview {
        margin-top: 16px;
        display: grid;
        gap: 14px;
        min-width: 0;
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 16px;
    }

    .preview-bar {
        color: #5f6b67;
        font-size: 13px;
    }

    .kpis {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 8px;
    }

    .kpi {
        border: 1px solid #d8ddda;
        border-top: 3px solid #263ba6;
        border-radius: 4px;
        padding: 10px 12px;
        background: #fff;
        min-width: 0;
    }

    .kpi.red {
        border-top-color: #b3261e;
    }

    .kpi b {
        display: block;
        font-size: 22px;
        line-height: 1.15;
        font-weight: 700;
    }

    .kpi .cap {
        display: block;
        margin-top: 4px;
        font-size: 11px;
        line-height: 1.35;
        letter-spacing: 0.04em;
        color: #5f6b67;
        font-weight: 600;
        text-transform: uppercase;
    }

    .delta.down {
        color: #b3261e;
    }

    .delta.up {
        color: #137a4a;
    }

    .band {
        background: #263ba6;
        color: #fff;
        font-size: 12px;
        font-weight: 650;
        letter-spacing: 0.06em;
        padding: 8px 10px;
        border-radius: 3px;
    }

    .trend-scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .trend {
        display: grid;
        grid-template-columns: repeat(12, minmax(36px, 1fr));
        gap: 4px;
        align-items: end;
        min-height: 120px;
        min-width: 480px;
        padding-top: 4px;
    }

    .trend .col {
        display: grid;
        gap: 4px;
        align-content: end;
        justify-items: center;
        text-align: center;
        min-height: 110px;
        padding: 4px 2px 0;
        border-radius: 3px;
    }

    .trend .col.sel {
        background: #eceef8;
        color: #263ba6;
        font-weight: 650;
    }

    .trend .bar {
        display: block;
        width: 70%;
        max-width: 28px;
        min-height: 0;
        border-radius: 2px 2px 0 0;
        background: #b3261e;
    }

    .trend .bar.amber {
        background: #d08a00;
    }

    .trend .bar.green {
        background: #137a4a;
    }

    .trend .bar.empty {
        background: transparent;
    }

    .trend .name,
    .trend .pct {
        font-size: 10px;
        line-height: 1.2;
        color: #5f6b67;
        max-width: 100%;
        overflow-wrap: anywhere;
    }

    .trend .col.sel .name,
    .trend .col.sel .pct {
        color: #263ba6;
        font-weight: 650;
    }

    .tbl {
        overflow-x: auto;
        border: 1px solid #d8ddda;
        border-radius: 6px;
        background: #fff;
        -webkit-overflow-scrolling: touch;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        font-size: 13px;
        font-variant-numeric: tabular-nums;
    }

    .tbl > table {
        min-width: 560px;
    }

    details.questions .tbl > table {
        min-width: 420px;
    }

    th,
    td {
        text-align: left;
        padding: 8px 10px;
        border-bottom: 1px solid #d8ddda;
        vertical-align: middle;
    }

    th {
        font-size: 11px;
        letter-spacing: 0.05em;
        color: #5f6b67;
        background: #f7f8f7;
        font-weight: 650;
    }

    tr:last-child td {
        border-bottom: 0;
    }

    .meter {
        width: 100px;
        max-width: 100%;
        height: 6px;
        background: #d8ddda;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        border-radius: 99px;
        overflow: hidden;
    }

    .meter i {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: #b3261e;
    }

    .meter.amber i {
        background: #d08a00;
    }

    .meter.green i {
        background: #137a4a;
    }

    .score {
        display: inline-block;
        min-width: 42px;
        text-align: center;
        font-weight: 700;
        padding: 2px 6px;
        border-radius: 3px;
        background: #f7d6d2;
        color: #b3261e;
    }

    .score.amber {
        background: #fbe6bd;
        color: #9a6a00;
    }

    .score.green {
        background: #dff1e6;
        color: #137a4a;
    }

    .score.empty {
        background: #f7f8f7;
        color: #5f6b67;
    }

    .status {
        display: inline-block;
        padding: 2px 8px;
        border-radius: 99px;
        font-size: 12px;
        font-weight: 650;
        background: #f7f8f7;
        color: #5f6b67;
    }

    .status.red {
        background: #f7d6d2;
        color: #b3261e;
    }

    .status.amber {
        background: #fbe6bd;
        color: #9a6a00;
    }

    .status.green {
        background: #dff1e6;
        color: #137a4a;
    }

    details.questions {
        margin-top: 8px;
    }

    details.questions summary {
        cursor: pointer;
        color: #263ba6;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .customer-card {
        border: 1px solid #d8ddda;
        border-radius: 8px;
        background: #fff;
        padding: 12px;
        display: grid;
        gap: 10px;
        min-width: 0;
    }

    .customer-head {
        display: flex;
        justify-content: space-between;
        gap: 8px;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .customer-head h3 {
        margin: 0;
        font-size: 15px;
        line-height: 1.3;
    }

    .customer-meta {
        color: #5f6b67;
        font-size: 12px;
        margin-top: 2px;
    }

    .stack {
        display: grid;
        gap: 12px;
    }

    @media (max-width: 900px) {
        .kpis {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    @media (max-width: 640px) {
        padding: 4px 12px 64px;

        h1 {
            font-size: 20px;
        }

        .panel {
            padding: 14px;
        }

        .field,
        .field.report-type,
        .field.months,
        .field.customers,
        .seg,
        .seg button {
            width: 100%;
            max-width: 100%;
            min-width: 0;
        }

        .seg {
            display: flex;
        }

        .seg button {
            flex: 1 1 0;
            white-space: normal;
        }

        .btns,
        .btn {
            width: 100%;
        }

        .kpis {
            grid-template-columns: minmax(0, 1fr);
        }
    }
`
